import PublicationShipmentAppService from "../../../../application/platform/publication-shipment/publication-shipment-app-service";
import { FileBase64Response } from "../../../../model/base/response/file-base-64-response";
import { IListPublicationShipmentPagedRequest } from "../../../../model/publication-shipment/request/list-publication-shipment-paged-request";
import { IListUsersSendpPublicationShipmentRequest } from "../../../../model/publication-shipment/request/list-users-publication-shipment-request";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import { ACTION_TYPES, useConsultaRemessaDispatch, useConsultaRemessaState } from "./consulta-remessa-context";

export const useConsultaRemessaController = () => {
    const consultRmessaDispatch = useConsultaRemessaDispatch();
    const { listPublicationShipmentPagedRequest, updatePublicationShipmentRequest } = useConsultaRemessaState();
    const { showBackDrop, showMessage } = useBaseLayoutController();

    const downloadFile = async (submissionPublicationId: number, fileId: number): Promise<FileBase64Response> => {

        showBackDrop(true);

        var response = await PublicationShipmentAppService.downloadFile(submissionPublicationId, fileId);

        showBackDrop(false);

        return response;
    }

    const downloadFiles = async (submissionPublicationId: number): Promise<FileBase64Response> => {
        showBackDrop(true);
        var response = await PublicationShipmentAppService.downloadFiles(submissionPublicationId);
        showBackDrop(false);

        return response;
    }

    const list = async (request: IListPublicationShipmentPagedRequest) => {
        consultRmessaDispatch({
            type: ACTION_TYPES.setIsLoadingData,
            payload: true,
        });

        var result = await PublicationShipmentAppService.list(request);
        consultRmessaDispatch({
            type: ACTION_TYPES.seListPublicationShipmentResponse,
            payload: result,
        });

        consultRmessaDispatch({
            type: ACTION_TYPES.setIsLoadingData,
            payload: false,
        });

    }

    const update = async () => {
        showBackDrop(true);
        await PublicationShipmentAppService.update(updatePublicationShipmentRequest);

        showMessage({ type: 'success', message: 'Remessa alterada com sucesso.' });

        showBackDrop(false);

await list(listPublicationShipmentPagedRequest);
    
    }

    const clearFields = async () => {
        var request = { page: 0, pageSize: 50, id: "" } as IListPublicationShipmentPagedRequest
        
        await consultRmessaDispatch({
            type: ACTION_TYPES.setListPublicationShipmentPagedRequest,
            payload: request,
        });

        await list(request);
    }

    const getDetail = async (id: number) => {
        consultRmessaDispatch({
            type: ACTION_TYPES.setIsLoadingData,
            payload: true,
        });

        var result = await PublicationShipmentAppService.getById(id);

        consultRmessaDispatch({
            type: ACTION_TYPES.setDetailPublicationShipmentResponse,
            payload: result,
        });

        consultRmessaDispatch({
            type: ACTION_TYPES.setIsLoadingData,
            payload: false,
        });

    }

    const onChangePagination = async (page: number, pageSize: number) => {
        var request = { ...listPublicationShipmentPagedRequest, page, pageSize } as IListPublicationShipmentPagedRequest
        consultRmessaDispatch({
            type: ACTION_TYPES.setListPublicationShipmentPagedRequest,
            payload: request,
        });

        await list(request);
    }

    const getInit = async () => {
        var status = await PublicationShipmentAppService.listStatus();
        consultRmessaDispatch({
            type: ACTION_TYPES.setListSatusPublicatioShipment,
            payload: status,
        });

        var usersSend = await PublicationShipmentAppService.listUsersSend({} as IListUsersSendpPublicationShipmentRequest);

        consultRmessaDispatch({
            type: ACTION_TYPES.setListUsersSend,
            payload: usersSend,
        });
        await clearFields();
    }
    const handleOnChangeUpdate = (e: any) => {
        let statusId = updatePublicationShipmentRequest.statusId;
        let diagramerObservation = updatePublicationShipmentRequest.diagramerObservation;


        if (e.target.name === "input-diagramerObservation") {
            diagramerObservation = e.target.value;
        }

        if (e.target.name === "select-status") {
            statusId = e.target.value;
        }

        consultRmessaDispatch({
            type: ACTION_TYPES.setUpdatePublicationShipmentRequest,
            payload: { ...updatePublicationShipmentRequest, statusId, diagramerObservation },
        });
    }

    const handleOnChange = (e: any) => {
        let statusId = listPublicationShipmentPagedRequest.statusId;
        let types = listPublicationShipmentPagedRequest.types;
        let id = listPublicationShipmentPagedRequest.id;
        let userSenderId = listPublicationShipmentPagedRequest.userSenderId;

        if (e.target.name === "input-id") {
            id = e.target.value;
        }

        if (e.target.name === "select-type") {
            types = e.target.value;
        }

        if (e.target.name === "select-status") {
            statusId = e.target.value;
        }

        if (e.target.name === "select-user-id") {
            userSenderId = e.target.value;
        }

        consultRmessaDispatch({
            type: ACTION_TYPES.setListPublicationShipmentPagedRequest,
            payload: { ...listPublicationShipmentPagedRequest, id, types, statusId, userSenderId },
        });
    };

    return {
        handleOnChange, handleOnChangeUpdate, clearFields, getInit, update, list, onChangePagination, getDetail, downloadFile, downloadFiles
    };
}